import React, {useReducer} from 'react';
import MatchInfo from 'app/components/match/matchData/MatchInfo';
import ProfileLinkRow from 'app/components/profile/ProfileLinkRow';
import {ContentWithStickyBanner} from 'app/styles/content';
import {Subheading} from 'app/styles/heading';
import {LOADING_MESSAGE, LoadingIndicator, Placeholder} from '@fupa/fupa-uikit';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {useParams} from 'react-router';
import {MatchInfoPageReducer} from 'app/routes/match/MatchPageReducer';
import {fetchMatchInfo} from 'app/routes/match/MatchPageActions';

const MatchInfoPage = () => {
  const {restoredData} = useRestoreData('MatchInfoPage');
  const {matchSlug} = useParams();
  const initialData = {
    isFetching: false,
    data: {},
    error: null,
  };
  const initialState = restoredData ?? initialData;

  const [state, dispatch] = useReducer(MatchInfoPageReducer, initialState);
  const loadData = () => {
    return fetchMatchInfo(matchSlug)(dispatch, state);
  };
  const {data, isFetching} = state;
  useFetchData(state, loadData, 'MatchInfoPage');

  const ref = data?.referee;
  const refereeName = `${ref?.firstName} ${ref?.lastName}`;

  const displayMatchReferee =
    ref || data?.refereeAlias ? (
      <ProfileLinkRow
        isDeactivated={ref?.isDeactivated}
        profileSlug={ref?.slug}
        profileName={data.refereeAlias || refereeName}
        profileImage={ref?.image}
        additionalInformation={ref?.club?.name || 'Unbekannter Verein'}
        type='referee'
        subheading='Schiedsrichter'
      />
    ) : (
      <>
        <Subheading variant='subheading2'>Schiedsrichter</Subheading>
        <Placeholder>Kein Schiedsrichter angegeben.</Placeholder>
      </>
    );

  const displayMatchInfo = Object.keys(data).length ? <MatchInfo info={data} /> : null;

  const content = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor />
  ) : (
    <>
      {displayMatchReferee}
      {displayMatchInfo}
    </>
  );

  return <ContentWithStickyBanner>{content}</ContentWithStickyBanner>;
};

export default MatchInfoPage;
